import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    placeholder: String,
  }

  connect() {
    $(this.element).select2(this.select2Options)
  }

  disconnect() {
    if ($(this.element).data("select2")) {
      $(this.element).select2("destroy")
    }
    $(this.element).siblings(".select2-container").remove()
  }

  get select2Options() {
    const options = {}

    if (this.hasPlaceholderValue) {
      options.placeholder = this.placeholderValue
    }

    return options
  }
}
